<section [hidden]="tenderId" id="ms-container">
  <!--Header part-->
  <div id="ms-header">
    <div id="tender-search-header">
      <div id="tender-search-title">
        {{ 'tenders.search-title' | translate }}
      </div>
      <div class="search-header-container d-flex flex-column py-2 px-4">
        <div class="d-flex">
          <app-tenders-filter
            inTenderSearchView
            [tenderSearchService]="tenderSearchService"
            [filters]="[FilterType.PERIOD]"
            [defaultPeriod]="defaultPeriod"
          >
          </app-tenders-filter>
          <app-tender-toggle-text-btn [(showFilters)]="showFilters" class="pdl-8px" />
        </div>
        <div class="tenders-filters" [hidden]="!showFilters">
          <app-tenders-filter
            [tenderSearchService]="tenderSearchService"
            [filters]="[FilterType.TERRITORY, FilterType.TENDER_TYPE, FilterType.MARKET_TYPE]"
          />
        </div>
      </div>
    </div>
    <div *ngIf="tenders?.length || tenderSearchService.refinedSearchText" class="result-header-bar d-flex">
      <app-tenders-summary [tendersSearchService]="tenderSearchService" />
      <div class="sort-container ms-auto">
        <ex-filter-text
          [placeholder]="'tenders.filter-results' | translate"
          [text]="tenderSearchService.refinedSearchText"
          (textEnter)="onRefineResults($event)"
        />
        <app-tenders-sort
          [tendersSearchService]="tenderSearchService"
          [defaultSort]="organisationQueryParam ? 'indexation_date' : '_score'"
        />
        <app-tenders-action-toggle [disabled]="!tenderSearchService.tenders?.length" />
      </div>
    </div>
  </div>

  <app-tenders-list
    [tendersSearchService]="tenderSearchService"
    [tendersExportService]="tendersExportService"
    [ngClass]="{ 'background-image': tenders === undefined || (tenders?.length === 0 && !tenderSearchService.refinedSearchText) }"
  />
  <app-tenders-action-bar [tendersSearchService]="tenderSearchService" />
</section>

<router-outlet> </router-outlet>
